module.exports = __webpack_public_path__ + "static/media/email.b6dc28f1.PNG";